var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { span: 24 } },
    [
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Matrícula:",
              content: _vm.imovel.numeroMatricula || "-"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Livro:",
              content: _vm.imovel.livroMatricula || "-"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Folha:",
              content: _vm.imovel.numeroFolhaMatricula || "-"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Nome do cartório:",
              content: _vm.imovel.nomeCartorio || "-"
            }
          })
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 12 } },
        [
          _c("app-display", {
            attrs: {
              label: "Município do cartório:",
              content: _vm.imovel.municipioCartorio.nome || "-"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-819daa5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-819daa5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesRegistroImovel.vue
// module id = null
// module chunks = 